module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('shared-product-edit', {
    attrs: {
      "product": _vm.product,
      "images": _vm.images
    }
  }, [(_vm.availableMatch) ? _c('div', {
    attrs: {
      "slot": "body-bottom-left"
    },
    slot: "body-bottom-left"
  }, [_c('panel', {
    staticClass: "blue-panel",
    attrs: {
      "title": "Produto selecionado no match"
    }
  }, [_c('panel', [_c('div', {
    staticClass: "l-row"
  }, [_c('div', {
    staticClass: "l-col-1@md img-product"
  }, [_c('div', {
    staticClass: "l-col-4@md"
  }, [_c('circle-chart', {
    attrs: {
      "percent": _vm.availableMatch.percent,
      "color": _vm.percentColor(_vm.availableMatch.percent)
    }
  }, [_vm._v("\n                " + _vm._s(_vm.availableMatch.percent) + "%\n              ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "l-col-2@md u-textCenter"
  }, [_c('img', {
    staticClass: "product-availablematch-img",
    attrs: {
      "src": _vm.availableMatch.image
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "l-col-9@md"
  }, [_c('div', {
    staticClass: "l-row"
  }, [_c('div', {
    staticClass: "l-col-12@md available-title"
  }, [_vm._v(_vm._s(_vm.availableMatch.title))]), _vm._v(" "), _c('div', {
    staticClass: "l-col-3@md"
  }, [_c('span', [_c('strong', [_vm._v("EAN:")]), _vm._v(" " + _vm._s(_vm.availableMatch.ean))])]), _vm._v(" "), _c('div', {
    staticClass: "l-col-3@md"
  }, [_c('span', [_c('strong', [_vm._v("Marca:")]), _vm._v(" " + _vm._s(_vm.availableMatch.brand))])]), _vm._v(" "), _vm._l((_vm.availableMatch.attributes), function(attribute) {
    return _c('div', {
      key: attribute,
      staticClass: "l-col-3@md"
    }, [_c('span', [_c('strong', [_vm._v(_vm._s(attribute.label) + ":")]), _vm._v(" " + _vm._s(_vm.formatAttribute(attribute.value)))])])
  })], 2)])])])], 1)], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4d01da83","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/marketplace/cnova/ProductEdit.vue
// module id = 3144
// module chunks = 0